module.exports = __webpack_public_path__ + "img/illustration_success.26ee896f.png";